import styled from "styled-components";
import MuiBlock from "./MuiCustoms";
import { useForm } from "react-hook-form";
import { Button, TextField } from "@mui/material";
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import Breakpoints from "../config/Breakpoints";

const PaginationContainer = styled(MuiBlock)`
    display: flex;
    gap: .5rem;
    align-items: center;
    justify-content: flex-end;
    font-size: var(--font-size-sm);

    @media ${Breakpoints.max.sm} {
        justify-content: center;
    }
`;

const LuckyNumberPagination = ({currentPage, totalPages, setCurrentPage}) => {
    const {register, setValue, getValues} = useForm();

    const prevPage = () => {
        setValue('pageNumber', getValues('pageNumber') - 1);
        setCurrentPage(prevValue => prevValue - 1);
    }

    const nextPage = () => {
        setValue('pageNumber', getValues('pageNumber') + 1);
        setCurrentPage(prevValue => prevValue + 1);
    }

    const setPageTo = (ev) => {
        if(ev.target.value === '' || ev.target.value > totalPages || ev.target.value < 0) {
            ev.target.value = currentPage;
            return;
        } 
        setCurrentPage(parseInt(ev.target.value));
    }

    const setPageValue = (ev) => {
        if(isNaN(ev.key) && ev.key !== 'Backspace' && ev.key !== 'ArrowLeft' && ev.key !== 'ArrowRight') {
            ev.preventDefault();
        }
        if(ev.key === 'Enter') {
            setPageTo(ev);
        }
    }

    return totalPages > 1 && (
        <PaginationContainer>
            {currentPage > 1 && <Button onClick={prevPage} className="button"><KeyboardArrowLeftOutlinedIcon fontSize="small"/> Anterior</Button>}
            <TextField 
                {...register('pageNumber', {
                    onBlur: setPageTo,
                    valueAsNumber: true,
                    value: currentPage,
                })}
                onKeyDown={setPageValue}
                type="tel" 
                variant="outlined" 
                style={{width: '3.5rem'}} 
                size="small" 
            /> de {totalPages}
            {currentPage < totalPages && <Button onClick={nextPage} className="button">Próximo <KeyboardArrowRightOutlinedIcon fontSize="small" /></Button>}
        </PaginationContainer>
    )
}

export default LuckyNumberPagination;